import TemplateModal from './TemplateModal.vue'

const CustomModal = {
  install(Vue) {

    this.EventBus = new Vue()

    Vue.component('app-modal', TemplateModal)

    Vue.prototype.$modal = {
      info(content) {
        CustomModal.EventBus.$emit('info', content)
      },
      alert(msg, details, callBack) {
        CustomModal.EventBus.$emit('alert', { msg, details, callBack })
      },
      error(msg, details) {
        CustomModal.EventBus.$emit('error', { msg, details })
      },
      confirm(content, callBackOnConfirm) {
        CustomModal.EventBus.$emit('confirm', { content, callBackOnConfirm })
        },

      custom(content, buttons) {
        CustomModal.EventBus.$emit('custom', { content, buttons })
        }
    }
  }
}

export default CustomModal